import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import itPortalService from "../services/itPortalService";
import SideBar from "../components/SideBar";

export default function ITPortalDashboard() {
  const [configs, setConfigs] = useState({
    login_max_attempts: 5,
    login_lockout_duration_minutes: 15
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchConfigs();
  }, []);

  const fetchConfigs = async () => {
    setIsLoading(true);
    try {
      const response = await itPortalService.getConfigs();
      if (response.data && response.data.configs) {
        const configData = response.data.configs;
        const mappedConfigs = {};
        configData.forEach(item => {
          mappedConfigs[item.config_key] = item.config_value;
        });
        setConfigs({
          login_max_attempts: mappedConfigs.login_max_attempts || 5,
          login_lockout_duration_minutes: mappedConfigs.login_lockout_duration_minutes || 15
        });
      }
    } catch (err) {
      if (err.response?.status === 403 && err.response?.data?.requires_it_portal_otp) {
        // Redirect to IT Portal login if unauthorized
        navigate("/it-portal");
      } else {
        setError("Failed to load configurations.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setError("");
    setSuccessMsg("");

    try {
      await itPortalService.updateConfigs({
        login_max_attempts: parseInt(configs.login_max_attempts),
        login_lockout_duration_minutes: parseInt(configs.login_lockout_duration_minutes)
      });
      setSuccessMsg("Configurations updated successfully.");
    } catch (err) {
      if (err.response?.status === 403 && err.response?.data?.requires_it_portal_otp) {
        navigate("/it-portal");
      } else {
        setError("Failed to update configurations.");
      }
    } finally {
      setIsSaving(false);
      setTimeout(() => setSuccessMsg(""), 3000);
    }
  };

  const handleChange = (e) => {
    setConfigs({
      ...configs,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#F8F9FA' }}>
      <SideBar />
      <div style={{ flex: 1, padding: '20px' }}>
        <div style={{ maxWidth: "600px", margin: "40px auto", padding: "30px", background: "#fff", borderRadius: "8px", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
          <h2 style={{ marginBottom: "20px", color: "#19224D", borderBottom: "2px solid #f1f1f1", paddingBottom: "10px" }}>Security Settings</h2>
          
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>Loading configurations...</div>
          ) : (
            <form onSubmit={handleSave}>
              {error && <div style={{ color: "red", marginBottom: "15px", padding: "10px", background: "#ffe6e6", borderRadius: "4px" }}>{error}</div>}
              {successMsg && <div style={{ color: "green", marginBottom: "15px", padding: "10px", background: "#e6ffe6", borderRadius: "4px" }}>{successMsg}</div>}

              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold", color: "#333" }}>
                  Max Failed Login Attempts
                </label>
                <input
                  type="number"
                  name="login_max_attempts"
                  min="1"
                  max="20"
                  value={configs.login_max_attempts}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    fontSize: "16px"
                  }}
                  required
                />
                <small style={{ color: "#777", display: "block", marginTop: "5px" }}>
                  The number of incorrect login attempts allowed before the account is temporarily locked.
                </small>
              </div>

              <div style={{ marginBottom: "30px" }}>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold", color: "#333" }}>
                  Lockout Duration (Minutes)
                </label>
                <input
                  type="number"
                  name="login_lockout_duration_minutes"
                  min="1"
                  value={configs.login_lockout_duration_minutes}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    fontSize: "16px"
                  }}
                  required
                />
                <small style={{ color: "#777", display: "block", marginTop: "5px" }}>
                  How long the user will be locked out for after exceeding the maximum failed attempts.
                </small>
              </div>

              <button 
                type="submit" 
                disabled={isSaving}
                style={{
                  background: "#19224D",
                  color: "#fff",
                  padding: "12px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: isSaving ? "not-allowed" : "pointer",
                  fontSize: "16px",
                  width: "100%",
                  fontWeight: "bold"
                }}
              >
                {isSaving ? "Saving..." : "Save Configurations"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
